<div class="page-loader">
  <div class="page-loader__image">
    <img alt="Man in stoel met vrouw ernaast" src="assets/images/people-chairs-1.png" />
  </div>
  <div class="page-loader__content">
    <img alt="Univé Unibol" src="assets/images/unibol.png" />
    <h1 class="page-loader__title"><ng-content></ng-content></h1>
  </div>
</div>
